var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{on:{"click":function($event){return _vm.$emit('emClicked')}}},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),(_vm.caption)?_c('figcaption',{class:{animate: _vm.animate},domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }